import { call, put, takeLatest, select } from "redux-saga/effects";

import globalTypes from "reducers/types/global";
import { types, selectors } from "reducers/status";
import { types as loginTypes } from "reducers/login";
import { types as sessionTypes, selectors as sessionSelectors } from "reducers/session";
import * as middleware from "middleware/session";

import { getTimeInMillis, delay } from "util/config";

const sagas = [
    takeLatest([globalTypes.INIT, loginTypes.LOGIN_SUCCESS, sessionTypes.EXTEND_SUCCESS], sessionExpirationCheck),
];

export default sagas;

function* sessionExpirationCheck() {
    const status = yield select(selectors.getStatus);
    const isLoggedIn = yield select(sessionSelectors.isLoggedIn);

    if (isLoggedIn) {
        const secondsBeforeExpirationNotification = Math.floor(
            getTimeInMillis("session.timeBeforeTimeoutNotification", 30000) / 1000,
        );
        let secondsToExpire;

        while (true) {
            try {
                const { data } = yield call(middleware.check);
                const { secondsToExpire: secondsToExpireResponse } = data.data;
                secondsToExpire = secondsToExpireResponse;
            } catch (err) {
                if ((err.response && err.response.status === 401) || err.status === 401) {
                    yield put({ type: sessionTypes.EXPIRE });
                    break;
                }
                yield call(delay, secondsBeforeExpirationNotification * 1000);
            }

            // ARBIBIMPLE-9890: Starter kit muestra modal para extender la session
            // si el modal se mostraban mas de 2 veces, automaticamente se cierra la sesion
            // if (status.sessionExtendedCount === 2) {
            //     yield call(delay, secondsToExpire * 1000);
            //     yield put({ type: sessionTypes.EXPIRE });
            //     break;
            // }

            // if (secondsToExpire <= secondsBeforeExpirationNotification) {
            //     yield put({ type: types.SHOW_SESSION_EXPIRATION_MODAL, secondsToExpire });
            //     break;
            // }

            // ARBIBIMPLE-9890: En lugar de lo de arriba, no se muestra la notificacion
            // se cierra sesion luego de n periodo de inactividad
            if (secondsToExpire <= secondsBeforeExpirationNotification) {
                yield put({ type: sessionTypes.EXPIRE });
                break;
            }

            yield call(delay, (secondsToExpire - secondsBeforeExpirationNotification) * 1000);
        }
    }
}
